@if (data) {
<mat-card class="profile-card px-15 pb-20">
    <mat-card-header>
        <mat-card-title>
            <div class="g-just-flex gap-8">
                <div class="round-icon-wrapper contrast">
                    <mat-icon>
                        person
                    </mat-icon>
                </div>
                <span> {{practitionerPurpose?'Your Profile Details':'Patient Registration'}}</span>
            </div>
        </mat-card-title>

    </mat-card-header>
    <mat-card-content>
        <div class="my-10">
            <mat-divider>

            </mat-divider>


            <div class="my-20"></div>
            <div class="g-just-flex special-header-wrapper  my-20 mb-30 gap-18"
                style="justify-content: space-between; flex-wrap: wrap;">

                <div class="special-header g-just-flex gap-15" style="align-items: center; ">
                    <div class="icon">
                        <img [src]="getProfileImageUrl()" alt="Profile photo" srcset="">

                    </div>

                    <div class="words g-just-flex flex-column gap-15"
                        style="align-items: flex-start; font-size: 1.1rem;">
                        <strong>
                            <em>
                                <span>
                                    @if(data.name && data.name.length > 0){
                                    @let name = data.name[0];
                                    {{name.family | uppercase}} {{name.given?.join(" ")}}
                                    }@else {
                                    <span>No Name Provided</span>
                                    }
                                </span>


                            </em>

                        </strong>

                        <div class="g-just-flex gap-20">
                           @if(data && $any(data).status){
<div #sc
    [attr.class]="'small-chips'+' '+'status-'+statuStyles[$any(data).status.toLowerCase()]['color']+' g-just-flex gap-8'">
    <span> {{$any(data).status}}</span>
    <mat-icon>{{statuStyles[$any(data).status.toLowerCase()]['icon']}}</mat-icon>
</div>
}

                        </div>


                        <!-- <a
                        href="{{allMedications[0].medication.reference && allMedications[0].medication.reference.reference? allMedications[0].medication.reference.reference:''}}">

                        {{allMedications[0].medication.concept?allMedications[0].medication.concept!.coding![0]!.display:
                        allMedications[0].medication.reference?.display
                        || allMedications[0].medication.reference?.reference ||
                        allMedications[0].medication.reference?.identifier
                        }}
                    </a> -->
                    </div>
                </div>
                <!-- Replace the action-button section in the template with this: -->

                <div class="action-button mb-15 gap-18">
                    <!-- ARCHIVED: Show Reactivate and Delete (Check this FIRST) -->
                    @if(isArchived && !practitionerPurpose && !isPending) {
                    <a mat-flat-button class="header-group" (click)="reactivatePatient()">
                        <mat-icon>restore</mat-icon>
                        <span>Reactivate</span>
                    </a>
                    <a mat-flat-button class="header-group warn-button" (click)="deletePatient()">
                        <mat-icon>delete</mat-icon>
                        <span>Delete</span>
                    </a>
                    }

                    <!-- PENDING: Show Approve and Reject -->
                    @else if(isPending && !practitionerPurpose && !isArchived && !isDeceased && (canModeratePending$ |
                    async)) {
                    <a mat-flat-button class="header-group" (click)="approvePatient()">
                        <mat-icon>check_circle</mat-icon>
                        <span>Approve</span>
                    </a>
                    <button mat-flat-button class="header-group" (click)="rejectPatient()">
                        <mat-icon>cancel</mat-icon>
                        <span>Reject</span>
                    </button>
                    }

                    <!-- DECEASED: Show only View (no actions) -->
                    @else if(isDeceased && !practitionerPurpose) {
                    <!-- No action buttons for deceased patients -->
                    <span class="subtitle-text-color-2" style="padding: 8px 16px;">
                        <mat-icon style="vertical-align: middle; font-size: 18px;">info</mat-icon>
                        No actions available for deceased patients
                    </span>
                    }

                    <!-- APPROVED/ACTIVE: Show Edit and Archive -->
                    @else if(!isPending && !isArchived && !isDeceased && !practitionerPurpose && !isViewOnly) {
                    @if(canEditPatient$ | async) {
                    <a mat-flat-button class="header-group" (click)="editPatient()">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                    </a>
                    }
                    <a mat-flat-button class="header-group" (click)="archivePatient()">
                        <mat-icon>archive</mat-icon>
                        <span>Archive</span>
                    </a>
                    }

                    <!-- PRACTITIONER PURPOSE: Show Edit and Change Password -->
                    @else if(practitionerPurpose) {
                    <a mat-flat-button class="header-group" (click)="editPatient()">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                    </a>
                    <a mat-flat-button class="header-group" (click)="openChangePasswordModal()">
                        <mat-icon>lock_reset</mat-icon>
                        <span>Change Password</span>
                    </a>
                    }
                </div>
            </div>
            <mat-tab-group>

                <mat-tab [label]="practitionerPurpose ? 'Profile' : 'Patient'">
                    <div class="cards-wrapper my-30">
                        @if(data.name && data.name.length > 0){
                        <mat-card>

                            <mat-card-header>
                                <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                    <!-- <div class="header-icon">

                        </div> -->
                                    <div class="header-words  ">
                                        <div class="title-flex" class="g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                            <mat-icon>
                                                <!-- aan icon for name -->
                                                person
                                            </mat-icon> <mat-card-title>
                                                Name</mat-card-title>
                                        </div>
                                        <!-- <mat-card-subtitle class="subtitle-text-color" style="font-size: 1rem;">
                                    Medicine Details
                                </mat-card-subtitle> -->
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">


                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">


                                                        {{data.name[0].family || 'N/A'}}


                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Last Name / Surname' | titlecase}}
                                                </div>
                                            </div>
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">


                                                        {{data.name[0].given?.[0] || 'N/A'}}


                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'First Name' | titlecase}}
                                                </div>
                                            </div>
                                            @if(data.name[0].given && data.name[0].given.length > 1){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">

                                                        @for(otherName of data.name[0].given; track $index) {
                                                        @if($index > 0) {
                                                        {{otherName || 'N/A'}}
                                                        }
                                                        }

                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Other Names' | titlecase}}
                                                </div>
                                            </div>
                                            }




                                            <!--
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc
                                                [attr.class]="'small-chips'+' '+'status-'+intentStyles[allMedications[0].intent]['color']+' g-just-flex gap-8'">


                                                <span> {{allMedications[0].intent}}

                                                </span>
                                                <mat-icon>
                                                    {{intentStyles[allMedications[0].intent]['icon']}}
                                                </mat-icon>

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Intent' | titlecase}}
                                        </div>
                                    </div> -->

                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>


                        </mat-card>
                        }


                        @if(data.gender || data.birthDate || data.maritalStatus){
                        <mat-card>

                            <mat-card-header>
                                <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                    <!-- <div class="header-icon">

                        </div> -->
                                    <div class="header-words  ">
                                        <div class="title-flex" class="g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                            <mat-icon>
                                                <!-- aan icon for bio data -->
                                                info

                                            </mat-icon> <mat-card-title>
                                                Bio Data</mat-card-title>
                                        </div>
                                        <!-- <mat-card-subtitle class="subtitle-text-color" style="font-size: 1rem;">
                                    Medicine Details
                                </mat-card-subtitle> -->
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">

                                            @if(data.birthDate){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">


                                                        {{(data.birthDate | date : "mediumDate") || 'N/A'}}


                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Date of Birth' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                            @if(data.birthDate){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">


                                                        {{data.birthDate? (data.birthDate | age) +" Years": 'N/A'}}


                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Age' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                            @if(data.gender){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">


                                                        {{(data.gender | titlecase) || 'N/A'}}


                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Gender' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                            @if (data?.maritalStatus) {
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div class="value-with-icon">
                                                        {{
                                                        data.maritalStatus?.text
                                                        || data.maritalStatus?.coding?.[0]?.display
                                                        || 'N/A'
                                                        }}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    Marital Status
                                                </div>
                                            </div>
                                            }






                                            <!--
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc
                                                [attr.class]="'small-chips'+' '+'status-'+intentStyles[allMedications[0].intent]['color']+' g-just-flex gap-8'">


                                                <span> {{allMedications[0].intent}}

                                                </span>
                                                <mat-icon>
                                                    {{intentStyles[allMedications[0].intent]['icon']}}
                                                </mat-icon>

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Intent' | titlecase}}
                                        </div>
                                    </div> -->

                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>


                        </mat-card>
                        }
                        @if(data.address && data.address.length > 0){
                        <mat-card>

                            <mat-card-header>
                                <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                    <!-- <div class="header-icon">

                        </div> -->
                                    <div class="header-words  ">
                                        <div class="title-flex
                                    g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                            <mat-icon>
                                                <!-- aan icon for address -->
                                                home
                                            </mat-icon> <mat-card-title>
                                                Address</mat-card-title>
                                        </div>
                                        <!-- <mat-card-subtitle class="subtitle-text-color" style="font-size: 1rem;">
                                    Medicine Details
                                </mat-card-subtitle> -->
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">

                                            @for(address of data.address; track $index) {
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.line?.join(", ") || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Address Line' | titlecase}} @if(address.line &&
                                                    address.line.length > 1)
                                                    {
                                                    {{address.line.length - 1}} Other Lines
                                                    }
                                                </div>
                                            </div>
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.city || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'City' | titlecase}}
                                                </div>
                                            </div>
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.state || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'State' | titlecase}}
                                                </div>
                                            </div>
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.district || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'District' | titlecase}}
                                                </div>
                                            </div>
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.country || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Country' | titlecase}}
                                                </div>
                                            </div>
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.postalCode || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Postal Code' | titlecase}}
                                                </div>

                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>

                            </mat-card-content>
                        </mat-card>}
                        @if(data.telecom && data.telecom.length > 0){
                        <mat-card>

                            <mat-card-header>
                                <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                    <!-- <div class="header-icon">

                        </div> -->
                                    <div class="header-words  ">
                                        <div class="title-flex g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">

                                            <mat-icon>
                                                <!-- aan icon for contact -->
                                                contact_phone
                                            </mat-icon> <mat-card-title>
                                                Contact Details</mat-card-title>
                                        </div>
                                        <!-- <mat-card-subtitle class="subtitle-text-color" style="font-size: 1rem;">
                                    Medicine Details
                                </mat-card-subtitle> -->
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>

                                <div *ngFor="let telecom of data.telecom">
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">
                                                {{telecom.value || 'N/A'}}
                                            </div>
                                        </div>
                                        <div class="field-title">
                                            @if(telecom.use || telecom.system){ @if(telecom.system){
                                            {{
                                            (telecom.system | titlecase) }}
                                            }@if(telecom.use) {
                                            {{" - " +telecom.use | titlecase}}
                                            }}@else {
                                            {{'Contact'}}
                                            }
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }

                    </div>
                </mat-tab>
@if((!practitionerPurpose || data?.resourceType === 'Patient') && !isEditModeForPractitioner) {

<mat-tab label="Guardian / Dependent">

  <div class="cards-wrapper my-30 guardian-section">

    <!-- =========================================================
         SECTION 1: LINKED GUARDIAN RECORDS
    ========================================================== -->
    @if(hasGuardians) {

      <div class="section-label guardian-section-title">
        <mat-icon>link</mat-icon>
        <span>Linked Guardian Record(s)</span>
      </div>

      @for(guardian of resolvedGuardians; track guardian.id) {

        <mat-card class="guardian-card">

          <mat-card-header>
            <div class="guardian-card-header">
              <div class="title-flex">
                <mat-icon>supervisor_account</mat-icon>
                <mat-card-title>
                  Guardian (Linked Record)
                </mat-card-title>
              </div>
            </div>
          </mat-card-header>

          <mat-card-content>

            <div class="guardian-fields-grid">

              <!-- Guardian Name -->
              <div class="field-group">
                <div class="field-value">
                  {{ guardianDisplayName(guardian) || 'N/A' }}
                </div>
                <div class="field-title">
                  Guardian Name
                </div>
              </div>

              <!-- Relationship -->
              @if(guardianRelationship(guardian)) {
                <div class="field-group">
                  <div class="field-value">
                    {{ guardianRelationship(guardian) }}
                  </div>
                  <div class="field-title">
                    Relationship
                  </div>
                </div>
              }

              <!-- Gender -->
              @if(guardian.gender) {
                <div class="field-group">
                  <div class="field-value">
                    {{ guardian.gender | titlecase }}
                  </div>
                  <div class="field-title">
                    Gender
                  </div>
                </div>
              }

              <!-- Phone -->
              @if(guardianPhone(guardian)) {
                <div class="field-group">
                  <div class="field-value">
                    {{ guardianPhone(guardian) }}
                  </div>
                  <div class="field-title">
                    Phone
                  </div>
                </div>
              }

              <!-- Email -->
              @if(guardianEmail(guardian)) {
                <div class="field-group">
                  <div class="field-value">
                    {{ guardianEmail(guardian) }}
                  </div>
                  <div class="field-title">
                    Email
                  </div>
                </div>
              }

              <!-- Telecom -->
              @if(guardian.telecom && guardian.telecom.length > 0) {

                <div class="field-group guardian-full-width">

                  <div class="field-value guardian-contact-list">

                    @for(t of guardian.telecom; track $index) {

                      <div class="guardian-contact-item">

                        <span>
                          {{ t.value || 'N/A' }}
                        </span>

                        <span class="subtitle-text-color-2">
                          @if(t.system) {
                            ({{ t.system | titlecase }})
                          }

                          @if(t.use) {
                            - {{ t.use | titlecase }}
                          }
                        </span>

                      </div>

                    }

                  </div>

                  <div class="field-title">
                    Contact(s)
                  </div>

                </div>

              }

              <!-- Address -->
              @if(guardian.address && guardian.address.length > 0) {

                @let addr = guardian.address[0];

                @if(addr.line && addr.line.length > 0) {

                  <div class="field-group guardian-full-width">

                    <div class="field-value">
                      {{ addr.line.join(', ') }}
                    </div>

                    <div class="field-title">
                      Address
                    </div>

                  </div>

                }

                @if(addr.city) {

                  <div class="field-group">

                    <div class="field-value">
                      {{ addr.city }}
                    </div>

                    <div class="field-title">
                      City
                    </div>

                  </div>

                }

                @if(addr.state) {

                  <div class="field-group">

                    <div class="field-value">
                      {{ addr.state }}
                    </div>

                    <div class="field-title">
                      State
                    </div>

                  </div>

                }

                @if(addr.country) {

                  <div class="field-group">

                    <div class="field-value">
                      {{ addr.country }}
                    </div>

                    <div class="field-title">
                      Country
                    </div>

                  </div>

                }

              }

            </div>

          </mat-card-content>

        </mat-card>

      }

    }


    <!-- =========================================================
         SECTION 2: PATIENT CONTACT / REGISTRATION GUARDIAN
    ========================================================== -->
    @if(data.contact && data.contact.length > 0) {

      <div
        class="section-label guardian-section-title"
        [class.guardian-section-title-spaced]="hasGuardians">

        <mat-icon>contacts</mat-icon>

        <span>
          {{ hasGuardians
            ? 'Additional Contact Info (from registration)'
            : 'Guardian Details'
          }}
        </span>

      </div>


      @for(contact of data.contact; track $index) {

        <mat-card class="guardian-card">

          <mat-card-header>

            <div class="guardian-card-header">

              <div class="title-flex">

                <mat-icon>groups</mat-icon>

                <mat-card-title>
                  Guardian Details
                </mat-card-title>

              </div>

            </div>

          </mat-card-header>


          <mat-card-content>

            <div class="guardian-fields-grid">

              <!-- Guardian Name -->
              @if(contact.name) {

                <div class="field-group">

                  <div class="field-value">

                    {{ contact.name.family || '' }}

                    @if(contact.name.given && contact.name.given.length > 0) {
                      {{ contact.name.given.join(' ') }}
                    }

                    @if(!contact.name.family && !contact.name.given?.length) {
                      N/A
                    }

                  </div>

                  <div class="field-title">
                    Guardian Name
                  </div>

                </div>

              }


              <!-- Relationship -->
              @if(contact.relationship && contact.relationship.length > 0) {

                <div class="field-group">

                  <div class="field-value">

                    @let rel = contact.relationship[0];

                    {{
                      rel.text
                      || rel.coding?.[0]?.display
                      || rel.coding?.[0]?.code
                      || 'N/A'
                    }}

                  </div>

                  <div class="field-title">
                    Relationship
                  </div>

                </div>

              }


              <!-- Gender -->
              @if(contact.gender) {

                <div class="field-group">

                  <div class="field-value">
                    {{ contact.gender | titlecase }}
                  </div>

                  <div class="field-title">
                    Gender
                  </div>

                </div>

              }


              <!-- Contact Information -->
              @if(contact.telecom && contact.telecom.length > 0) {

                <div class="field-group guardian-full-width">

                  <div class="field-value guardian-contact-list">

                    @for(t of contact.telecom; track $index) {

                      <div class="guardian-contact-item">

                        <span>
                          {{ t.value || 'N/A' }}
                        </span>

                        <span class="subtitle-text-color-2">

                          @if(t.system) {
                            ({{ t.system | titlecase }})
                          }

                          @if(t.use) {
                            - {{ t.use | titlecase }}
                          }

                        </span>

                      </div>

                    }

                  </div>

                  <div class="field-title">
                    Contact(s)
                  </div>

                </div>

              }


              <!-- Address -->
              @if(contact.address) {

                @if(contact.address.line && contact.address.line.length > 0) {

                  <div class="field-group guardian-full-width">

                    <div class="field-value">
                      {{ contact.address.line.join(', ') }}
                    </div>

                    <div class="field-title">
                      Address
                    </div>

                  </div>

                }


                @if(contact.address.city) {

                  <div class="field-group">

                    <div class="field-value">
                      {{ contact.address.city }}
                    </div>

                    <div class="field-title">
                      City
                    </div>

                  </div>

                }


                @if(contact.address.state) {

                  <div class="field-group">

                    <div class="field-value">
                      {{ contact.address.state }}
                    </div>

                    <div class="field-title">
                      State
                    </div>

                  </div>

                }


                @if(contact.address.country) {

                  <div class="field-group">

                    <div class="field-value">
                      {{ contact.address.country }}
                    </div>

                    <div class="field-title">
                      Country
                    </div>

                  </div>

                }

              }

            </div>

          </mat-card-content>

        </mat-card>

      }

    }


    <!-- =========================================================
         EMPTY STATE
    ========================================================== -->
    @if(!hasGuardians && (!data.contact || data.contact.length === 0)) {

      <div class="guardian-empty-state">

        <mat-icon>
          info
        </mat-icon>

        <span>
          No Guardian Details Found
        </span>

      </div>

    }

  </div>

</mat-tab>

}              
<mat-tab [label]="practitionerPurpose ? 'Documents' : 'Attachment'">
                    @if(data.photo && data.photo.length > 0) {
                    <div class="cards-wrapper my-30">
                        @for(att of data.photo; track $index) {
                        <mat-card>
                            <mat-card-header>
                                <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                    <div class="header-words  ">
                                        <div class="title-flex g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start;
                    ">
                                            <mat-icon>attach_file</mat-icon>
                                            <mat-card-title>Attachment</mat-card-title>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">
                                            <div class="field-group" style="min-width: 280px;">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        @if(att.url){
                                                        <img [src]="att.url" alt="attachment"
                                                            style="max-height: 160px; border-radius: 6px;" />
                                                        }@else if(att.data && att.contentType){
                                                        <img [src]="'data:' + att.contentType + ';base64,' + att.data"
                                                            alt="attachment"
                                                            style="max-height: 160px; border-radius: 6px;" />
                                                        }@else {
                                                        <mat-icon>insert_drive_file</mat-icon>
                                                        }
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Preview' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{att.title || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Title' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{att.contentType || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Content Type' | titlecase}}
                                                </div>
                                            </div>

                                            @if(att.creation){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{att.creation | date: 'medium'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Created' | titlecase}}
                                                </div>
                                            </div>
                                            }

                                            @if(att.url){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        <a [href]="att.url" target="_blank">Open</a>
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Link' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }
                    </div>
                    }@else {
                    <div class="g-just-flex flex-column gap-15" style="align-items: center; justify-content: center;">
                        <mat-icon class="icon" style="font-size: 3rem;">info</mat-icon>
                        <span class="subtitle-text-color-2">No Attachment Found</span>
                    </div>}
                </mat-tab>
                <mat-tab label="Signature">
                    @if(signatureImageUrl) {
                    <div class="cards-wrapper my-30">
                        <mat-card>
                            <mat-card-header>
                                <div class="title-flex g-just-flex gap-8"
                                    style="align-items: center; justify-content: flex-start;">
                                    <mat-icon>draw</mat-icon>
                                    <mat-card-title>Registered Signature</mat-card-title>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-20" style="max-width: 640px;">
                                    <img [src]="signatureImageUrl" alt="Registered signature"
                                        style="width: 100%; border: 1px dashed var(--mat-sys-outline-variant); border-radius: 8px; background: #fff;" />
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    }@else {
                    <div class="g-just-flex flex-column gap-15" style="align-items: center; justify-content: center;">
                        <mat-icon class="icon" style="font-size: 3rem;">draw</mat-icon>
                        <span class="subtitle-text-color-2">No signature has been registered yet.</span>
                    </div>
                    }
                </mat-tab>
            </mat-tab-group>
        </div>
    </mat-card-content>
</mat-card>}